export default __webpack_public_path__ + "static/media/passport.03a3fe21.svg";